import { useReverseGeocodeQuery } from '../api';
/**
 * Hook to find an address by coordinates using OpenStreetMap Nominatim API.
 * Uses RTK Query for consistent API patterns and automatic caching.
 *
 * @param lat - Latitude coordinate
 * @param lon - Longitude coordinate
 * @returns Object containing the address string and loading state
 */
export const useFindAddressByCoordinates = (lat, lon) => {
    const { data, isLoading } = useReverseGeocodeQuery({ lat: lat, lon: lon }, { skip: lat === null || lon === null });
    return {
        address: data?.displayName ?? null,
        isLoading,
    };
};
